(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[1924],{

/***/ 94682:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  yB: () => (/* reexport */ GraphiQL)
});

// UNUSED EXPORTS: GraphiQLInterface, GraphiQLProvider, default

// EXTERNAL MODULE: ../../node_modules/.pnpm/@graphiql+react@0.19.3_@codemirror+language@6.10.2_@types+node@22.1.0_@types+react-dom@17.0.5_iwmydt5yuompjdbeetq7ml26ie/node_modules/@graphiql/react/dist/index.mjs + 90 modules
var dist = __webpack_require__(83797);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphiql@3.0.5_@codemirror+language@6.10.2_@types+node@22.1.0_@types+react-dom@17.0.5_@types+_vmulqhc3ykmby5b6rq66asyrce/node_modules/graphiql/esm/components/GraphiQL.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};


var majorVersion = parseInt(react.version.slice(0, 2), 10);
if (majorVersion < 16) {
    throw new Error([
        'GraphiQL 0.18.0 and after is not compatible with React 15 or below.',
        'If you are using a CDN source (jsdelivr, unpkg, etc), follow this example:',
        'https://github.com/graphql/graphiql/blob/master/examples/graphiql-cdn/index.html#L49',
    ].join('\n'));
}
function GraphiQL(_a) {
    var dangerouslyAssumeSchemaIsValid = _a.dangerouslyAssumeSchemaIsValid, defaultQuery = _a.defaultQuery, defaultTabs = _a.defaultTabs, externalFragments = _a.externalFragments, fetcher = _a.fetcher, getDefaultFieldNames = _a.getDefaultFieldNames, headers = _a.headers, inputValueDeprecation = _a.inputValueDeprecation, introspectionQueryName = _a.introspectionQueryName, maxHistoryLength = _a.maxHistoryLength, onEditOperationName = _a.onEditOperationName, onSchemaChange = _a.onSchemaChange, onTabChange = _a.onTabChange, onTogglePluginVisibility = _a.onTogglePluginVisibility, operationName = _a.operationName, plugins = _a.plugins, query = _a.query, response = _a.response, schema = _a.schema, schemaDescription = _a.schemaDescription, shouldPersistHeaders = _a.shouldPersistHeaders, storage = _a.storage, validationRules = _a.validationRules, variables = _a.variables, visiblePlugin = _a.visiblePlugin, defaultHeaders = _a.defaultHeaders, props = __rest(_a, ["dangerouslyAssumeSchemaIsValid", "defaultQuery", "defaultTabs", "externalFragments", "fetcher", "getDefaultFieldNames", "headers", "inputValueDeprecation", "introspectionQueryName", "maxHistoryLength", "onEditOperationName", "onSchemaChange", "onTabChange", "onTogglePluginVisibility", "operationName", "plugins", "query", "response", "schema", "schemaDescription", "shouldPersistHeaders", "storage", "validationRules", "variables", "visiblePlugin", "defaultHeaders"]);
    if (typeof fetcher !== 'function') {
        throw new TypeError('The `GraphiQL` component requires a `fetcher` function to be passed as prop.');
    }
    return (react.createElement(dist/* GraphiQLProvider */.j$, { getDefaultFieldNames: getDefaultFieldNames, dangerouslyAssumeSchemaIsValid: dangerouslyAssumeSchemaIsValid, defaultQuery: defaultQuery, defaultHeaders: defaultHeaders, defaultTabs: defaultTabs, externalFragments: externalFragments, fetcher: fetcher, headers: headers, inputValueDeprecation: inputValueDeprecation, introspectionQueryName: introspectionQueryName, maxHistoryLength: maxHistoryLength, onEditOperationName: onEditOperationName, onSchemaChange: onSchemaChange, onTabChange: onTabChange, onTogglePluginVisibility: onTogglePluginVisibility, plugins: plugins, visiblePlugin: visiblePlugin, operationName: operationName, query: query, response: response, schema: schema, schemaDescription: schemaDescription, shouldPersistHeaders: shouldPersistHeaders, storage: storage, validationRules: validationRules, variables: variables },
        react.createElement(GraphiQLInterface, __assign({ showPersistHeadersSettings: shouldPersistHeaders !== false }, props))));
}
GraphiQL.Logo = GraphiQLLogo;
GraphiQL.Toolbar = GraphiQLToolbar;
GraphiQL.Footer = GraphiQLFooter;
function GraphiQLInterface(props) {
    var _a, _b, _c;
    var isHeadersEditorEnabled = (_a = props.isHeadersEditorEnabled) !== null && _a !== void 0 ? _a : true;
    var editorContext = (0,dist/* useEditorContext */._i)({ nonNull: true });
    var executionContext = (0,dist/* useExecutionContext */.JB)({ nonNull: true });
    var schemaContext = (0,dist/* useSchemaContext */.J5)({ nonNull: true });
    var storageContext = (0,dist/* useStorageContext */.bN)();
    var pluginContext = (0,dist/* usePluginContext */.gp)();
    var copy = (0,dist/* useCopyQuery */.Xd)({ onCopyQuery: props.onCopyQuery });
    var merge = (0,dist/* useMergeQuery */.pQ)();
    var prettify = (0,dist/* usePrettifyEditors */.fE)();
    var _d = (0,dist/* useTheme */.Fg)(), theme = _d.theme, setTheme = _d.setTheme;
    var PluginContent = (_b = pluginContext === null || pluginContext === void 0 ? void 0 : pluginContext.visiblePlugin) === null || _b === void 0 ? void 0 : _b.content;
    var pluginResize = (0,dist/* useDragResize */.Xx)({
        defaultSizeRelation: 1 / 3,
        direction: 'horizontal',
        initiallyHidden: (pluginContext === null || pluginContext === void 0 ? void 0 : pluginContext.visiblePlugin) ? undefined : 'first',
        onHiddenElementChange: function (resizableElement) {
            if (resizableElement === 'first') {
                pluginContext === null || pluginContext === void 0 ? void 0 : pluginContext.setVisiblePlugin(null);
            }
        },
        sizeThresholdSecond: 200,
        storageKey: 'docExplorerFlex',
    });
    var editorResize = (0,dist/* useDragResize */.Xx)({
        direction: 'horizontal',
        storageKey: 'editorFlex',
    });
    var editorToolsResize = (0,dist/* useDragResize */.Xx)({
        defaultSizeRelation: 3,
        direction: 'vertical',
        initiallyHidden: (function () {
            if (props.defaultEditorToolsVisibility === 'variables' ||
                props.defaultEditorToolsVisibility === 'headers') {
                return;
            }
            if (typeof props.defaultEditorToolsVisibility === 'boolean') {
                return props.defaultEditorToolsVisibility ? undefined : 'second';
            }
            return editorContext.initialVariables || editorContext.initialHeaders
                ? undefined
                : 'second';
        })(),
        sizeThresholdSecond: 60,
        storageKey: 'secondaryEditorFlex',
    });
    var _e = __read((0,react.useState)(function () {
        if (props.defaultEditorToolsVisibility === 'variables' ||
            props.defaultEditorToolsVisibility === 'headers') {
            return props.defaultEditorToolsVisibility;
        }
        return !editorContext.initialVariables &&
            editorContext.initialHeaders &&
            isHeadersEditorEnabled
            ? 'headers'
            : 'variables';
    }), 2), activeSecondaryEditor = _e[0], setActiveSecondaryEditor = _e[1];
    var _f = __read((0,react.useState)(null), 2), showDialog = _f[0], setShowDialog = _f[1];
    var _g = __read((0,react.useState)(null), 2), clearStorageStatus = _g[0], setClearStorageStatus = _g[1];
    var children = react.Children.toArray(props.children);
    var logo = children.find(function (child) {
        return isChildComponentType(child, GraphiQL.Logo);
    }) || react.createElement(GraphiQL.Logo, null);
    var toolbar = children.find(function (child) {
        return isChildComponentType(child, GraphiQL.Toolbar);
    }) || (react.createElement(react.Fragment, null,
        react.createElement(dist/* ToolbarButton */.wC, { onClick: prettify, label: "Prettify query (Shift-Ctrl-P)" },
            react.createElement(dist/* PrettifyIcon */.Kt, { className: "graphiql-toolbar-icon", "aria-hidden": "true" })),
        react.createElement(dist/* ToolbarButton */.wC, { onClick: merge, label: "Merge fragments into query (Shift-Ctrl-M)" },
            react.createElement(dist/* MergeIcon */.Rn, { className: "graphiql-toolbar-icon", "aria-hidden": "true" })),
        react.createElement(dist/* ToolbarButton */.wC, { onClick: copy, label: "Copy query (Shift-Ctrl-C)" },
            react.createElement(dist/* CopyIcon */.TI, { className: "graphiql-toolbar-icon", "aria-hidden": "true" })), (_c = props.toolbar) === null || _c === void 0 ? void 0 :
        _c.additionalContent));
    var footer = children.find(function (child) {
        return isChildComponentType(child, GraphiQL.Footer);
    });
    var onClickReference = (0,react.useCallback)(function () {
        if (pluginResize.hiddenElement === 'first') {
            pluginResize.setHiddenElement(null);
        }
    }, [pluginResize]);
    var handleClearData = (0,react.useCallback)(function () {
        try {
            storageContext === null || storageContext === void 0 ? void 0 : storageContext.clear();
            setClearStorageStatus('success');
        }
        catch (_a) {
            setClearStorageStatus('error');
        }
    }, [storageContext]);
    var handlePersistHeaders = (0,react.useCallback)(function (event) {
        editorContext.setShouldPersistHeaders(event.currentTarget.dataset.value === 'true');
    }, [editorContext]);
    var handleChangeTheme = (0,react.useCallback)(function (event) {
        var selectedTheme = event.currentTarget.dataset.theme;
        setTheme(selectedTheme || null);
    }, [setTheme]);
    var handleAddTab = editorContext.addTab;
    var handleRefetchSchema = schemaContext.introspect;
    var handleReorder = editorContext.moveTab;
    var handleShowDialog = (0,react.useCallback)(function (event) {
        setShowDialog(event.currentTarget.dataset.value);
    }, []);
    var handlePluginClick = (0,react.useCallback)(function (e) {
        var context = pluginContext;
        var pluginIndex = Number(e.currentTarget.dataset.index);
        var plugin = context.plugins.find(function (_, index) { return pluginIndex === index; });
        var isVisible = plugin === context.visiblePlugin;
        if (isVisible) {
            context.setVisiblePlugin(null);
            pluginResize.setHiddenElement('first');
        }
        else {
            context.setVisiblePlugin(plugin);
            pluginResize.setHiddenElement(null);
        }
    }, [pluginContext, pluginResize]);
    var handleToolsTabClick = (0,react.useCallback)(function (event) {
        if (editorToolsResize.hiddenElement === 'second') {
            editorToolsResize.setHiddenElement(null);
        }
        setActiveSecondaryEditor(event.currentTarget.dataset.name);
    }, [editorToolsResize]);
    var toggleEditorTools = (0,react.useCallback)(function () {
        editorToolsResize.setHiddenElement(editorToolsResize.hiddenElement === 'second' ? null : 'second');
    }, [editorToolsResize]);
    var handleOpenShortKeysDialog = (0,react.useCallback)(function (isOpen) {
        if (!isOpen) {
            setShowDialog(null);
        }
    }, []);
    var handleOpenSettingsDialog = (0,react.useCallback)(function (isOpen) {
        if (!isOpen) {
            setShowDialog(null);
            setClearStorageStatus(null);
        }
    }, []);
    var addTab = (react.createElement(dist/* Tooltip */.u, { label: "Add tab" },
        react.createElement(dist/* UnStyledButton */.v0, { type: "button", className: "graphiql-tab-add", onClick: handleAddTab, "aria-label": "Add tab" },
            react.createElement(dist/* PlusIcon */.pO, { "aria-hidden": "true" }))));
    return (react.createElement(dist/* Tooltip */.u.Provider, null,
        react.createElement("div", { "data-testid": "graphiql-container", className: "graphiql-container" },
            react.createElement("div", { className: "graphiql-sidebar" },
                react.createElement("div", { className: "graphiql-sidebar-section" }, pluginContext === null || pluginContext === void 0 ? void 0 : pluginContext.plugins.map(function (plugin, index) {
                    var isVisible = plugin === pluginContext.visiblePlugin;
                    var label = "".concat(isVisible ? 'Hide' : 'Show', " ").concat(plugin.title);
                    var Icon = plugin.icon;
                    return (react.createElement(dist/* Tooltip */.u, { key: plugin.title, label: label },
                        react.createElement(dist/* UnStyledButton */.v0, { type: "button", className: isVisible ? 'active' : '', onClick: handlePluginClick, "data-index": index, "aria-label": label },
                            react.createElement(Icon, { "aria-hidden": "true" }))));
                })),
                react.createElement("div", { className: "graphiql-sidebar-section" },
                    react.createElement(dist/* Tooltip */.u, { label: "Re-fetch GraphQL schema" },
                        react.createElement(dist/* UnStyledButton */.v0, { type: "button", disabled: schemaContext.isFetching, onClick: handleRefetchSchema, "aria-label": "Re-fetch GraphQL schema" },
                            react.createElement(dist/* ReloadIcon */.BG, { className: schemaContext.isFetching ? 'graphiql-spin' : '', "aria-hidden": "true" }))),
                    react.createElement(dist/* Tooltip */.u, { label: "Open short keys dialog" },
                        react.createElement(dist/* UnStyledButton */.v0, { type: "button", "data-value": "short-keys", onClick: handleShowDialog, "aria-label": "Open short keys dialog" },
                            react.createElement(dist/* KeyboardShortcutIcon */.fY, { "aria-hidden": "true" }))),
                    react.createElement(dist/* Tooltip */.u, { label: "Open settings dialog" },
                        react.createElement(dist/* UnStyledButton */.v0, { type: "button", "data-value": "settings", onClick: handleShowDialog, "aria-label": "Open settings dialog" },
                            react.createElement(dist/* SettingsIcon */.ew, { "aria-hidden": "true" }))))),
            react.createElement("div", { className: "graphiql-main" },
                react.createElement("div", { ref: pluginResize.firstRef, style: {
                        minWidth: '200px',
                    } },
                    react.createElement("div", { className: "graphiql-plugin" }, PluginContent ? react.createElement(PluginContent, null) : null)),
                (pluginContext === null || pluginContext === void 0 ? void 0 : pluginContext.visiblePlugin) && (react.createElement("div", { className: "graphiql-horizontal-drag-bar", ref: pluginResize.dragBarRef })),
                react.createElement("div", { ref: pluginResize.secondRef, className: "graphiql-sessions" },
                    react.createElement("div", { className: "graphiql-session-header" },
                        react.createElement(dist/* Tabs */.mQ, { values: editorContext.tabs, onReorder: handleReorder, "aria-label": "Select active operation" }, editorContext.tabs.length > 1 && (react.createElement(react.Fragment, null,
                            editorContext.tabs.map(function (tab, index) { return (react.createElement(dist/* Tab */.OK, { key: tab.id, value: tab, isActive: index === editorContext.activeTabIndex },
                                react.createElement(dist/* Tab */.OK.Button, { "aria-controls": "graphiql-session", id: "graphiql-session-tab-".concat(index), onClick: function () {
                                        executionContext.stop();
                                        editorContext.changeTab(index);
                                    } }, tab.title),
                                react.createElement(dist/* Tab */.OK.Close, { onClick: function () {
                                        if (editorContext.activeTabIndex === index) {
                                            executionContext.stop();
                                        }
                                        editorContext.closeTab(index);
                                    } }))); }),
                            addTab))),
                        react.createElement("div", { className: "graphiql-session-header-right" },
                            editorContext.tabs.length === 1 && addTab,
                            logo)),
                    react.createElement("div", { role: "tabpanel", id: "graphiql-session", className: "graphiql-session", "aria-labelledby": "graphiql-session-tab-".concat(editorContext.activeTabIndex) },
                        react.createElement("div", { ref: editorResize.firstRef },
                            react.createElement("div", { className: "graphiql-editors".concat(editorContext.tabs.length === 1 ? ' full-height' : '') },
                                react.createElement("div", { ref: editorToolsResize.firstRef },
                                    react.createElement("section", { className: "graphiql-query-editor", "aria-label": "Query Editor" },
                                        react.createElement(dist/* QueryEditor */.WK, { editorTheme: props.editorTheme, keyMap: props.keyMap, onClickReference: onClickReference, onCopyQuery: props.onCopyQuery, onEdit: props.onEditQuery, readOnly: props.readOnly }),
                                        react.createElement("div", { className: "graphiql-toolbar", role: "toolbar", "aria-label": "Editor Commands" },
                                            react.createElement(dist/* ExecuteButton */._8, null),
                                            toolbar))),
                                react.createElement("div", { ref: editorToolsResize.dragBarRef },
                                    react.createElement("div", { className: "graphiql-editor-tools" },
                                        react.createElement(dist/* UnStyledButton */.v0, { type: "button", className: activeSecondaryEditor === 'variables' &&
                                                editorToolsResize.hiddenElement !== 'second'
                                                ? 'active'
                                                : '', onClick: handleToolsTabClick, "data-name": "variables" }, "Variables"),
                                        isHeadersEditorEnabled && (react.createElement(dist/* UnStyledButton */.v0, { type: "button", className: activeSecondaryEditor === 'headers' &&
                                                editorToolsResize.hiddenElement !== 'second'
                                                ? 'active'
                                                : '', onClick: handleToolsTabClick, "data-name": "headers" }, "Headers")),
                                        react.createElement(dist/* Tooltip */.u, { label: editorToolsResize.hiddenElement === 'second'
                                                ? 'Show editor tools'
                                                : 'Hide editor tools' },
                                            react.createElement(dist/* UnStyledButton */.v0, { type: "button", onClick: toggleEditorTools, "aria-label": editorToolsResize.hiddenElement === 'second'
                                                    ? 'Show editor tools'
                                                    : 'Hide editor tools', className: "graphiql-toggle-editor-tools" }, editorToolsResize.hiddenElement === 'second' ? (react.createElement(dist/* ChevronUpIcon */.g8, { className: "graphiql-chevron-icon", "aria-hidden": "true" })) : (react.createElement(dist/* ChevronDownIcon */.v4, { className: "graphiql-chevron-icon", "aria-hidden": "true" })))))),
                                react.createElement("div", { ref: editorToolsResize.secondRef },
                                    react.createElement("section", { className: "graphiql-editor-tool", "aria-label": activeSecondaryEditor === 'variables'
                                            ? 'Variables'
                                            : 'Headers' },
                                        react.createElement(dist/* VariableEditor */.hF, { editorTheme: props.editorTheme, isHidden: activeSecondaryEditor !== 'variables', keyMap: props.keyMap, onEdit: props.onEditVariables, onClickReference: onClickReference, readOnly: props.readOnly }),
                                        isHeadersEditorEnabled && (react.createElement(dist/* HeaderEditor */.LA, { editorTheme: props.editorTheme, isHidden: activeSecondaryEditor !== 'headers', keyMap: props.keyMap, onEdit: props.onEditHeaders, readOnly: props.readOnly })))))),
                        react.createElement("div", { className: "graphiql-horizontal-drag-bar", ref: editorResize.dragBarRef }),
                        react.createElement("div", { ref: editorResize.secondRef },
                            react.createElement("div", { className: "graphiql-response" },
                                executionContext.isFetching ? react.createElement(dist/* Spinner */.$j, null) : null,
                                react.createElement(dist/* ResponseEditor */.iB, { editorTheme: props.editorTheme, responseTooltip: props.responseTooltip, keyMap: props.keyMap }),
                                footer))))),
            react.createElement(dist/* Dialog */.Vq, { open: showDialog === 'short-keys', onOpenChange: handleOpenShortKeysDialog },
                react.createElement("div", { className: "graphiql-dialog-header" },
                    react.createElement(dist/* Dialog */.Vq.Title, { className: "graphiql-dialog-title" }, "Short Keys"),
                    react.createElement(dist/* Dialog */.Vq.Close, null)),
                react.createElement("div", { className: "graphiql-dialog-section" },
                    react.createElement(ShortKeys, { keyMap: props.keyMap || 'sublime' }))),
            react.createElement(dist/* Dialog */.Vq, { open: showDialog === 'settings', onOpenChange: handleOpenSettingsDialog },
                react.createElement("div", { className: "graphiql-dialog-header" },
                    react.createElement(dist/* Dialog */.Vq.Title, { className: "graphiql-dialog-title" }, "Settings"),
                    react.createElement(dist/* Dialog */.Vq.Close, null)),
                props.showPersistHeadersSettings ? (react.createElement("div", { className: "graphiql-dialog-section" },
                    react.createElement("div", null,
                        react.createElement("div", { className: "graphiql-dialog-section-title" }, "Persist headers"),
                        react.createElement("div", { className: "graphiql-dialog-section-caption" },
                            "Save headers upon reloading.",
                            ' ',
                            react.createElement("span", { className: "graphiql-warning-text" }, "Only enable if you trust this device."))),
                    react.createElement(dist/* ButtonGroup */.hE, null,
                        react.createElement(dist/* Button */.zx, { type: "button", id: "enable-persist-headers", className: editorContext.shouldPersistHeaders ? 'active' : '', "data-value": "true", onClick: handlePersistHeaders }, "On"),
                        react.createElement(dist/* Button */.zx, { type: "button", id: "disable-persist-headers", className: editorContext.shouldPersistHeaders ? '' : 'active', onClick: handlePersistHeaders }, "Off")))) : null,
                react.createElement("div", { className: "graphiql-dialog-section" },
                    react.createElement("div", null,
                        react.createElement("div", { className: "graphiql-dialog-section-title" }, "Theme"),
                        react.createElement("div", { className: "graphiql-dialog-section-caption" }, "Adjust how the interface looks like.")),
                    react.createElement(dist/* ButtonGroup */.hE, null,
                        react.createElement(dist/* Button */.zx, { type: "button", className: theme === null ? 'active' : '', onClick: handleChangeTheme }, "System"),
                        react.createElement(dist/* Button */.zx, { type: "button", className: theme === 'light' ? 'active' : '', "data-theme": "light", onClick: handleChangeTheme }, "Light"),
                        react.createElement(dist/* Button */.zx, { type: "button", className: theme === 'dark' ? 'active' : '', "data-theme": "dark", onClick: handleChangeTheme }, "Dark"))),
                storageContext ? (react.createElement("div", { className: "graphiql-dialog-section" },
                    react.createElement("div", null,
                        react.createElement("div", { className: "graphiql-dialog-section-title" }, "Clear storage"),
                        react.createElement("div", { className: "graphiql-dialog-section-caption" }, "Remove all locally stored data and start fresh.")),
                    react.createElement(dist/* Button */.zx, { type: "button", state: clearStorageStatus || undefined, disabled: clearStorageStatus === 'success', onClick: handleClearData }, {
                        success: 'Cleared data',
                        error: 'Failed',
                    }[clearStorageStatus] || 'Clear data'))) : null))));
}
var modifier = typeof window !== 'undefined' &&
    window.navigator.platform.toLowerCase().indexOf('mac') === 0
    ? 'Cmd'
    : 'Ctrl';
var SHORT_KEYS = Object.entries({
    'Search in editor': [modifier, 'F'],
    'Search in documentation': [modifier, 'K'],
    'Execute query': [modifier, 'Enter'],
    'Prettify editors': ['Ctrl', 'Shift', 'P'],
    'Merge fragments definitions into operation definition': [
        'Ctrl',
        'Shift',
        'M',
    ],
    'Copy query': ['Ctrl', 'Shift', 'C'],
    'Re-fetch schema using introspection': ['Ctrl', 'Shift', 'R'],
});
function ShortKeys(_a) {
    var keyMap = _a.keyMap;
    return (react.createElement("div", null,
        react.createElement("table", { className: "graphiql-table" },
            react.createElement("thead", null,
                react.createElement("tr", null,
                    react.createElement("th", null, "Short Key"),
                    react.createElement("th", null, "Function"))),
            react.createElement("tbody", null, SHORT_KEYS.map(function (_a) {
                var _b = __read(_a, 2), title = _b[0], keys = _b[1];
                return (react.createElement("tr", { key: title },
                    react.createElement("td", null, keys.map(function (key, index, array) { return (react.createElement(react.Fragment, { key: key },
                        react.createElement("code", { className: "graphiql-key" }, key),
                        index !== array.length - 1 && ' + ')); })),
                    react.createElement("td", null, title)));
            }))),
        react.createElement("p", null,
            "The editors use",
            ' ',
            react.createElement("a", { href: "https://codemirror.net/5/doc/manual.html#keymaps", target: "_blank", rel: "noopener noreferrer" }, "CodeMirror Key Maps"),
            ' ',
            "that add more short keys. This instance of Graph",
            react.createElement("em", null, "i"),
            "QL uses",
            ' ',
            react.createElement("code", null, keyMap),
            ".")));
}
function GraphiQLLogo(props) {
    return (react.createElement("div", { className: "graphiql-logo" }, props.children || (react.createElement("a", { className: "graphiql-logo-link", href: "https://github.com/graphql/graphiql", target: "_blank", rel: "noreferrer" },
        "Graph",
        react.createElement("em", null, "i"),
        "QL"))));
}
GraphiQLLogo.displayName = 'GraphiQLLogo';
function GraphiQLToolbar(props) {
    return react.createElement(react.Fragment, null, props.children);
}
GraphiQLToolbar.displayName = 'GraphiQLToolbar';
function GraphiQLFooter(props) {
    return react.createElement("div", { className: "graphiql-footer" }, props.children);
}
GraphiQLFooter.displayName = 'GraphiQLFooter';
function isChildComponentType(child, component) {
    var _a;
    if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) &&
        child.type.displayName === component.displayName) {
        return true;
    }
    return child.type === component;
}
//# sourceMappingURL=GraphiQL.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphiql@3.0.5_@codemirror+language@6.10.2_@types+node@22.1.0_@types+react-dom@17.0.5_@types+_vmulqhc3ykmby5b6rq66asyrce/node_modules/graphiql/esm/index.js


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 48555:
/***/ ((module) => {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ })

}]);